// extracted by mini-css-extract-plugin
module.exports = {"detailDiv":"FlightDetails_detailDiv__1L615"};